import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {fa},
        current: "fa",
       /* rtl: {
            fa: true,
        },*/
    },

    theme: {
        themes: {
            light: {
                autumncolor: "#bd6203",
                wintercolor: "#021b98",
                springcolor: "#64b117",
                summercolor:"#fbc326",

            },
        },
    },


});
